module.exports = __webpack_public_path__ + "img/crying.f64d647f.png";